/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconCaretDown from '@telus-uds/palette-allium/build/rn/icons/CaretDown'
import PaletteIconCaretUp from '@telus-uds/palette-allium/build/rn/icons/CaretUp'
const theme = {
  appearances: {
    dropdown: {
      description: 'activate the dropdown menu',
      type: 'variant',
      values: [ true ]
    },
    equalWidth: {
      description: 'Divide the available width equally among `TabsItem`',
      type: 'variant',
      values: [ true ]
    },
    focus: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    inverse: { type: 'variant', values: [ true ] },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      description: "The design uses height of 3: there's (rightly) no '3' in the Allium palette but the effect is 1px above and below a 1px line",
      if: { selected: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        color: '#4b286d',
        highlightBarBorderRadius: 32,
        highlightBarBorderWidth: 1,
        highlightBarHeight: 1,
        highlightColor: '#4b286d'
      }
    },
    {
      if: { hover: true },
      tokens: { borderColor: '#b2b9bf', borderWidth: 2 }
    },
    {
      if: { focus: true },
      tokens: { borderColor: '#4b286d', borderWidth: 2, color: '#4b286d' }
    },
    {
      if: { pressed: true },
      tokens: {
        backgroundColor: '#676e73',
        borderColor: 'transparent',
        borderWidth: 0,
        color: '#ffffff'
      }
    },
    {
      if: { focus: true, pressed: true },
      tokens: { backgroundColor: '#4b286d' }
    },
    {
      if: { inverse: true },
      tokens: { backgroundColor: 'rgba(0, 0, 0, 0)', color: '#ffffff' }
    },
    {
      if: { hover: true, inverse: true },
      tokens: { borderColor: '#ffffff', highlightColor: '#ffffff' }
    },
    {
      if: { inverse: true, selected: true },
      tokens: {
        backgroundColor: '#ffffff',
        color: '#414547',
        highlightColor: '#ffffff'
      }
    },
    {
      if: { inverse: true, pressed: true },
      tokens: {
        backgroundColor: '#ffffff',
        color: '#414547',
        highlightColor: '#ffffff'
      }
    },
    {
      if: { focus: true, inverse: true },
      tokens: { borderColor: '#ffffff', highlightColor: '#ffffff' }
    },
    { if: { equalWidth: true }, tokens: { maxWidth: null } },
    {
      if: { dropdown: true, viewport: [ 'xs', 'sm' ] },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderRadius: 32,
        borderWidth: 3,
        color: '#676e73',
        paddingHorizontal: 21,
        paddingVertical: 5
      }
    },
    {
      if: { dropdown: true, hover: true, viewport: [ 'xs', 'sm' ] },
      tokens: {
        backgroundColor: '#ffffff',
        borderColor: '#b2b9bf',
        borderWidth: 3
      }
    },
    {
      if: { dropdown: true, focus: true, viewport: [ 'xs', 'sm' ] },
      tokens: {
        borderColor: '#4b286d',
        borderWidth: 2,
        color: '#4b286d',
        paddingHorizontal: 22,
        paddingVertical: 6
      }
    },
    {
      if: { dropdown: true, pressed: true, viewport: [ 'xs', 'sm' ] },
      tokens: {
        backgroundColor: '#4b286d',
        borderColor: '#4b286d',
        color: '#ffffff',
        paddingHorizontal: 24,
        paddingVertical: 8
      }
    },
    {
      if: { dropdown: true, selected: true, viewport: [ 'xs', 'sm' ] },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        borderWidth: 0,
        color: '#4b286d',
        paddingHorizontal: 24,
        paddingVertical: 8
      }
    },
    {
      if: { dropdown: true, inverse: true, viewport: [ 'xs', 'sm' ] },
      tokens: { backgroundColor: 'rgba(255, 255, 255, 0.1)', color: '#ffffff' }
    },
    {
      if: {
        dropdown: true,
        hover: true,
        inverse: true,
        viewport: [ 'xs', 'sm' ]
      },
      tokens: { borderColor: '#ffffff' }
    },
    {
      if: {
        dropdown: true,
        inverse: true,
        selected: true,
        viewport: [ 'xs', 'sm' ]
      },
      tokens: { backgroundColor: '#ffffff', color: '#414547' }
    },
    {
      if: {
        dropdown: true,
        inverse: true,
        pressed: true,
        viewport: [ 'xs', 'sm' ]
      },
      tokens: { backgroundColor: '#ffffff', color: '#414547' }
    },
    {
      if: {
        dropdown: true,
        focus: true,
        inverse: true,
        viewport: [ 'xs', 'sm' ]
      },
      tokens: { borderColor: '#ffffff' }
    }
  ],
  tokens: {
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    borderRadius: 32,
    borderWidth: 0,
    color: '#676e73',
    dropdownIcon: PaletteIconCaretDown,
    dropdownIconExpanded: PaletteIconCaretUp,
    fontName: 'HNforTELUSSA',
    fontScaleCap: 64,
    fontSize: 14,
    fontWeight: '700',
    highlightBarBorderRadius: 0,
    highlightBarBorderWidth: 0,
    highlightBarHeight: 0,
    highlightColor: 'transparent',
    highlightTriangleSize: 0,
    letterSpacing: 0,
    lineHeight: 1.14285714286,
    marginHorizontal: 0,
    marginVertical: 0,
    maxWidth: 192,
    paddingHorizontal: 24,
    paddingVertical: 8,
    space: 1,
    textAlign: 'center',
    textTransform: 'none'
  }
}
export default theme
